// src/components/layout/ActionPageLayout/ActionPageLayout.tsx
import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../../sidebar/Sidebar";
import Navbar from "../../../navbar/Navbar";
import { Card, CardContent } from "@mui/material";
import "../../pageLayout.scss";

interface ActionPageLayoutProps {
  icon?: React.ElementType;
  title: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

const MOBILE_BREAKPOINT = 768;

const ActionPageLayout: React.FC<ActionPageLayoutProps> = ({
  icon: Icon,
  title,
  children,
  actions,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (isMobile && sidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [isMobile, sidebarOpen]);

  const handleToggle = useCallback(() => setSidebarOpen((v) => !v), []);
  const handleClose = useCallback(() => setSidebarOpen(false), []);

  return (
    <div className="pageContainer">
      {isMobile && sidebarOpen && (
        <div className="sidebar-backdrop" onClick={handleClose} />
      )}

      <Sidebar isOpen={sidebarOpen} onClose={handleClose} isMobile={isMobile} />

      <div className="contentContainer">
        <Navbar onMenuToggle={handleToggle} />
        <div className="mainContent">
          <Card className="mainCard">
            <div className="cardHeader">
              {Icon && <Icon className="headerIcon" />}
              <h1 className="headerTitle">{title}</h1>
            </div>
            <CardContent className="cardContent">
              {children}
            </CardContent>
            {actions && (
              <div style={{
                padding: "16px 24px",
                borderTop: "1px solid rgba(0,0,0,0.07)",
                display: "flex",
                justifyContent: "flex-end",
                gap: 12,
              }}>
                {actions}
              </div>
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ActionPageLayout;
